// The better-auth client, pinned to the version the backend runs (1.4.21) — same as
// tkt-back-office lib/authClient.js. Its baseURL comes from lib/backendUrl, the one resolver the
// REST helpers also use, so the session cookie and every better-auth call share one host.
import { createAuthClient } from 'better-auth/react';
import { adminClient, emailOTPClient, organizationClient } from 'better-auth/client/plugins';
import { passkeyClient } from '@better-auth/passkey/client';
import { getBackendUrl } from './backendUrl.js';

export const authClient = createAuthClient({
  baseURL: getBackendUrl(),
  fetchOptions: { credentials: 'include' },
  plugins: [passkeyClient(), emailOTPClient(), adminClient(), organizationClient()],
});
